import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ADM, GFE } from '~/constants/perfil';

import { UnidataTable } from '~/components';
import { number } from '~/helpers';
import {
  findOperacaoExtratoDadosCapaTnqPostos,
  recordFiltering,
} from '~/store/modules/operacaoextratodadoscapatnqpostos/actions';

function OperacaoExtratoDadosCapaTnqPostos() {
  const { profile } = useSelector((state) => state.user);

  const operacaoextratodadoscapatnqpostos = useSelector(
    (state) => state.operacaoextratodadoscapatnqpostos
  );

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      switch (profile.glousuariotipo) {
        case ADM:
        case GFE:
          break;
        default:
      }
    }
    return function cleanup() {
      mounted = false;
    };
  }, [profile]);

  const header = useMemo(
    () => [
      {
        id: 'codigoposto',
        label: 'Codigo Posto',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'descricaoposto',
        label: 'Descrição Posto',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'tanquefisico',
        label: 'Tanque Físico',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'produto',
        label: 'Produto',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'capacidade',
        label: 'Capacidade',
        align: 'right',
        formatted: (value) => number(value, 1),
        precision: '1',
      },
      {
        id: 'volumecontabil',
        label: 'Volume Contabil',
        align: 'right',
        formatted: (value) => number(value, 1),
        precision: '1',
      },
      {
        id: 'pervolume',
        label: '% Volume',
        align: 'right',
        formatted: (value) => number(value, 3),
        precision: '3',
      },
    ],
    []
  );

  return (
    <>
      <UnidataTable
        pdf
        excel
        reportOrder="codigoposto ASC"
        create={false}
        delete={false}
        update={false}
        title={'Extração de dados da capacidade de tanque de todos os postos'}
        fixed
        header={header}
        find={findOperacaoExtratoDadosCapaTnqPostos}
        redux={operacaoextratodadoscapatnqpostos}
        read={recordFiltering}
        detach="descricaoposto"
        keys={['codigoposto', 'tanquefisico']}
        view="VW_CAPACIDADE_TNQ_POSTOS_SEM_REPLACE"
        reportTitle="Capacidade de Tanque"
      />
    </>
  );
}

export default OperacaoExtratoDadosCapaTnqPostos;
